<div (click)="close()" [class]="{'modal-overlay-visible': settings?.hasBackdrop, 'modal-overlay': !settings?.hasBackdrop}">
    <div class="modal-content" (click)="isolate($event)">
      <button
        *ngIf="settings?.showCloseButton"
        type="button"
        class="scaffold-dialog-frame-close"
        (click)="closeFromButton(); $event.stopPropagation()"
        aria-label="Close">
        <i class="fa-thin fa-xmark"></i>
      </button>
      <ng-template #content></ng-template>
    </div>
</div>
